/**
 * Convert byte to MB rounded to 1 decimal place
 *
 * @documented
 * @category Function
 * @param {Number} bytes
 * @example
 *
 * 		byteToMBRounded(10000000000)
 *
 */ const byteToMBRounded = (size)=>Math.round(size / 1000000 * 10) / 10;
export default byteToMBRounded;
